import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '../../__mocks__/@auth0/auth0-react';

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    // Wait for the Auth0 SDK to finish reading its cached session — firing
    // loginWithRedirect while isLoading is true sends already-authenticated
    // users through a needless Auth0 round trip (?code=... flash).
    if (isLoading || isAuthenticated) {
      return;
    }
    const returnTo = (location.state as { returnTo?: string } | null)?.returnTo;
    loginWithRedirect(returnTo ? { appState: { returnTo } } : undefined);
  }, [isLoading, isAuthenticated, loginWithRedirect, location.state]);

  return <></>;
};

export default Login;
